import { useCallback, useState } from "react";
import "./index.scss";

const INDEX_LETTERS = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export const IndexSearch = ({ onClickIndex }) => {
  const [currentIndex, setCurrentIndex] = useState("");
  const handleClick = useCallback(
    (letter) => {
      setCurrentIndex(letter);
      onClickIndex("name", letter);
    },
    [onClickIndex]
  );

  return (
    <div className="index-search">
      <span className="brand-index-title">BRAND INDEX:</span>
      {INDEX_LETTERS.map((letter) => (
        <button
          key={letter}
          onClick={() => handleClick(letter)}
          className={`index-button ${
            currentIndex === letter ? "selected" : ""
          }`}
          disabled={currentIndex === letter}
        >
          {letter}
        </button>
      ))}
    </div>
  );
};
